export enum NoaStatusId {
  Uploaded = 1,
  ReadyToConvert = 2,
  // 3 should not be used
  // 4 should not be used
  Removed = 5,
  // 6 should not be used
  Converted = 7,
  ConversionError = 8,
  ReadyToProcess = 9,
  // 10 should not be used
  ConversionErrorNotified = 11,
  ReadyToAudit = 12,
  Complete = 13,
  ActionConflict = 14,
  Deferred = 15,
  DeferredAndNotified = 16,
  RequestToSplit = 17,
  PendingNewFactor = 18,
  PendingLorValidation = 19,
  FraudInvestigation = 20,
  Held = 21,
  PendingOcr = 22,
  Deprecated = 23,
  PendingLorDesignation = 24,
  PendingLorDesignationHighRisk = 25,
  FraudConfirmed = 26,
}

export enum NoaStepId {
  AddAssignedFactor = 1,
  AddCarrier = 2,
  AddCarrierMC = 3,
  AddFactorToNotifyEmail = 4,
  AddFactorToNotify = 5,
  AddPayor = 6,
  AddLetterOfRelease = 7,
  AddLetterOfReleaseTypeId = 8,
  AddNoticeOfAssignment = 9,
  ConfirmDuplicateNoa = 10,
  ConfirmSpam = 11,
  Review = 12,
  SelectPayeeMatches = 13,
}

// these are effectively the same as NoaStatusId, but this is actually a separate
// table in the C# code
export enum NoaDocumentStatusId {
  Uploaded = 1,
  ReadyToConvert = 2,
  // 3 should not be used
  Removed = 5,
  // 6 should not be used
  Converted = 7,
  ConversionError = 8,
  ReadyToProcess = 9,
  // 10 should not be used
  ConversionErrorNotified = 11,
  ReadyToAudit = 12,
  Complete = 13,
  ActionConflict = 14,
  Deferred = 15,
  DeferredAndNotified = 16,
  RequestToSplit = 17,
}

export enum NoaRejectReasonId {
  MultipleCarriersListed = 1,
  BrokerNotSpecified = 2,
  InvalidSubmissionMethod = 3,
  InvalidBroker = 4,
  InvalidRelationship = 5,
  LorRequired = 6,
  IncorrectCarrierInformation = 7,
  InvalidFactor = 8,
  MissingMcDot = 9,
  Spam = 10,
  DuplicateNoa = 11,
  ConversionFailure = 12,
  NeedsToBeSplit = 13,
  SplitComplete = 14,
  PendingNewFactorComplete = 15,
  MarkAsFraud = 16,
  ClearedOfFraud = 17,
  Ignored = 18,
  ConfirmAsFraud = 19,
}

export enum LetterOfReleaseTypeId {
  GlobalLor = 1,
  SingleDebtorLor = 2,
}
